import { ComponentType, useMemo } from 'react'
import styles from './Multiples.module.scss'
import Circle from './Circle'
import { CircleProps } from '../models'

interface DotLegendProps {
  legendItems?: { name: string; fill: string }[]
  circleRadius?: number
  CircleInstance?: ComponentType<CircleProps>
}

export default function DotLegend({
  legendItems = [],
  circleRadius = 10,
  CircleInstance = Circle,
}: DotLegendProps) {
  const circleDiameter = useMemo(() => circleRadius * 2, [circleRadius])
  return (
    <div className={styles.legendWrapper}>
      {legendItems.map((item, index) => (
        <div className={styles.legendItemWrapper} key={item.name ?? index}>
          <div className={styles.legendItem}>
            <svg
              viewBox={`0 0 ${circleDiameter} ${circleDiameter}`}
              width={circleDiameter}
              height={circleDiameter}
              style={{ fill: item.fill }}
            >
              <CircleInstance
                id={`key-${index}`}
                x={circleRadius}
                y={circleRadius}
                r={circleRadius}
                fill={item.fill}
                opacity={1}
              />
            </svg>
            <p className={styles.legendText}>{item.name}</p>
          </div>
        </div>
      ))}
    </div>
  )
}
